import { Grid, styled } from "@mui/material";
import MxIcons from "@rf-l1/MxIcons";
import { IconCloudUpload } from "@tabler/icons-react";
import MxTypography from "@rf-l1/MxTypography";
import MxInputLabel from "@rf-l1/form/MxInputLabel";
import { MxHeaderDocViewer } from "@rf-l1/form/files-fields/MxFileViewerField";

interface EmptyFileUploadProps {
  label: string;
  maxSize: number;
  allowedTypes: string[];
}
const EmptyFileUploadv2 = (props: EmptyFileUploadProps) => {
  return (
    <ContentDotted container item xs={12}>
      {/* <MxHeaderDocViewer file={null} /> */}
      <Grid container item xs={12} textAlign="center" justifyContent="center">
        <MxInputLabel
          sx={{
            position: "relative"
          }}
          shrink={false}
        >
          {props.label}
        </MxInputLabel>
      </Grid>
      <Grid container item xs={12} justifyContent="center">
        <MxIcons
          color="#64748b"
          size={48}
          children={<IconCloudUpload stroke={1.5} />}
        />
      </Grid>
      <Grid container item xs={12} rowGap={0.5}>
        <Grid item xs={12} textAlign="center">
          <MxTypography variant="caption" color="grey.700">
            Tamaño máximo de {props.maxSize} MB
          </MxTypography>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <MxTypography variant="overline" color="grey.500">
            Archivos permitidos {props.allowedTypes.join(", ")}
          </MxTypography>
        </Grid>
      </Grid>
    </ContentDotted>
  );
};

export default EmptyFileUploadv2;

const ContentDotted = styled(Grid)(({ theme }) => ({
  border: "2px dashed #ccc",
  borderRadius: 8,
  height: 225,
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  transition: "all 0.5s ease",
  "&:hover svg": {
    transform: "scale(1.05)"
  }
}));
